// Adds click-and-drag scrolling for mouse users to a native horizontal scroller.
// Touch and trackpads keep native scrolling; a drag never triggers the link under it.
class SDragScroll extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.track = this.querySelector('[data-drag-track]') || this;

    let startX = 0;
    let startScroll = 0;
    let pointerId = null;
    let moved = false;

    this.track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = this.track.scrollLeft;
      moved = false;
    }, { signal });

    this.track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        this.track.setPointerCapture(pointerId);
        this.track.dataset.dragging = 'true';
      }
      if (moved) this.track.scrollLeft = startScroll - dx;
    }, { signal });

    const end = () => {
      if (pointerId === null) return;
      if (this.track.hasPointerCapture?.(pointerId)) this.track.releasePointerCapture(pointerId);
      pointerId = null;
      delete this.track.dataset.dragging;
    };
    this.track.addEventListener('pointerup', end, { signal });
    this.track.addEventListener('pointercancel', end, { signal });

    this.track.addEventListener('click', (event) => {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, { capture: true, signal });

    this.track.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

customElements.define('s-drag-scroll', SDragScroll);
